import { useDispatch } from "react-redux";
import {
  connectToMicrosoft365forSignup,
  connectToMicrosoft365forSignin,
  connectToGoogleForSignup,
  connectToGoogleForSignin,
} from "../../../actionCreator/socialAuthActionCreator";
import { useAlert } from "../../../context/AlertProvider";

export const useSocialAuth = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();

  const originURL = window.location.origin;
  const microsoft365Connect = async (isSignin) => {
    let res;
    if (isSignin) {
      res = await dispatch(
        connectToMicrosoft365forSignin({ origin: originURL })
      );
    } else {
      res = await dispatch(
        connectToMicrosoft365forSignup({ origin: originURL })
      );
    }
    if (res?.status === 200) {
      window.open(res?.data);
    } else {
      showAlert("error", `Something went wrong. Please try again.`);
    }
  };

  const googleConnect = async (isSignin) => {
    let res;
    if (isSignin) {
      res = await dispatch(connectToGoogleForSignin({ origin: originURL }));
    } else {
      res = await dispatch(connectToGoogleForSignup({ origin: originURL }));
    }
    if (res?.status === 200) {
      window.open(res?.data);
    } else {
      showAlert("error", `Something went wrong. Please try again.`);
    }
  };

  return {
    microsoft365Connect,
    googleConnect,
  };
};
